import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetRealtorRatingListSucceed, EGetRealtorRatingActionType } from './types';
import { IRealtorRatingList } from '../../../types/realtorRatingList';

export const getRealtorRatingListSucceed: (data: IRealtorRatingList) => TGetRealtorRatingListSucceed = actionGenerator<
  EGetRealtorRatingActionType.Succeed,
  IRealtorRatingList
>(EGetRealtorRatingActionType.Succeed);
